import { LocalStorage } from "quasar";
import { isDue } from "../../../util/misc.js";
import { cloneDeep, get } from "lodash";

export const backup = () => (path) => {
  return LocalStorage.getItem("backup/" + path) || null;
};

export const preferences = (state) => (type) => {
  return cloneDeep(get(state.user, "preferences." + type));
};

export const due = () => isDue;
